<template>

<div id="app">
    <el-container class="flextext">
      <home-head></home-head>
      <el-main class="neitong_bufen_qiangzhi">
        <div class="content">
          <!-- <el-tag closable v-if="js_zhi" @close="juese_sc_sj()">{{js_zhi.title}}</el-tag>
          <el-tag closable v-if="bujian" @close="bujian_sc_sj()" style="margin-left: 20px">{{bujian}}</el-tag>
          <el-tag closable v-if="ly_zhi" @close="lingyu_sc_sj()" style="margin-left: 20px">{{ly_zhi.title}}</el-tag> -->

          <div class="main-heads">
            
            <div style="width: 95%; margin: 0 auto;position: relative">
              <div >

                <div class="search-tops">分类：</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in category" :key="index">
                    <a class="a_color" style="width:100%" :class="{checked: checked_category == item1.id }" @click="do_check_category( item1.id )" :title="item1.name">
                      <div style="width:unset" class="search-tops-title" id="showLabelAndAttrName"> {{ item1.name }}</div>
                    </a>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <el-row :gutter="10" style="margin-top: 20px;">
            <el-col :xs="12" :sm="12" :md="6" v-for="(item,index) in goods_list" :key="index">
              <div class="shebei-item">
                <a v-bind:href="'#/self_goods/' + item.id ">
                  <div class="backgd">
                    <el-image :src="url+'/storage/'+item.image" fit="cover" style="position: relative">
                      <div slot="error" class="image-slot">
                        <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 220px">
                      </div>
                    </el-image>
                    <div class="erhsoushangpin">自营</div>
                  </div>
                  <div style="width: 100%;height: 21px">
                    <p style="text-align: center;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#404040">{{item.title}}</p>
                  </div>
                  <div style="text-align: center">
                    <span class="priceses">
                      <span class="money"></span>
                      <span class="value" style="font-size:14px">{{ item.name }}</span>
                    </span>
                  </div>
                </a>
                
              </div>
            </el-col>
          </el-row>


          <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
               style="line-height: 5.1em;margin-top: 60px">
            <div data-v-6af373ef="" class="el-pagination is-background">
              <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
              <el-pagination
                      style="float: left"
                      layout="prev, pager, next"
                      @current-change="yedianji"
                      :total="zuidayema*10">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>


      <footerall></footerall>
    </el-container>
  </div>

</template>    

<script>

import home_head from '../../common/home-head';
import footerall from "../../common/footer";

export default {
    name: "self_goods",

    data:function(){

        return {

            url:'',
            category:[],
            goods_list:[],
            checked_category:'',
            zuoshuL: '',
            zuidayema: '',

            current_page:1,
            paginate:12,
        }
    },

    methods:{

        init:function(){

            this.get_category();
            this.get_list();
            this.url = window.config.api_url
        },

        get_list:function(){

            var t = this;
            var url = window.config.api_url + '/college/self/goods/indexbypage';
            url += '?paginate=' + this.paginate;
            url += '&page=' + this.current_page;
            url += '&category=' + this.checked_category;
            t.axios.get(url).then(res => {

                t.goods_list = res.data.data;
                t.zuoshuL = res.data.total;
                t.zuidayema = res.data.last_page;
            })

        },

        get_category:function(){

            var t = this;
            var url = window.config.api_url + '/college/self/category/index'
            t.axios.get(url).then(res => {
                if (res.data == '') {
                    return console.log(res.data, 908)
                }
                t.category = res.data
            })

        },

        do_check_category : function( category_id ){

          if( this.checked_category == category_id ){
            this.checked_category = '';
          }else{
            this.checked_category = category_id;
          }

          this.get_list();


        },

        yedianji(e) {
            this.current_page = e;
            this.get_list()
        }

    },
    components: {
        'home-head': home_head,
        footerall
    },

    created:function(){

        this.init();
    }

}

</script>

<style>

.checked{
  background-color: #4E6EF2;
}
.checked .search-tops-title{
  color:#fff;
}
  .neitong_bufen_qiangzhi .el-tag--light {
    background-color: #4E6EF2 !important;
    color: #FFFFFF !important;
  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #4E6EF2;

  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4E6EF2;
  }

  .el-checkbox__inner {
    margin-left: -15px;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__inner:hover {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4E6EF2 !important;
    border-color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down {
    font-size: 0px !important;
    color: #666666 !important;
  }

  .jilian_xuanzeqi_wenzi_yangshi {
    font-size: 18px !important;

  }

  .neitong_bufen_qiangzhi .el-input__inner {
    border: 0px !important;
  }

  .neitong_bufen_qiangzhi .el-tag {
    text-align: center;
    width: 120px;
    margin-top: 20px;
    padding: 0;
    height: 24px;
    line-height: 24px;
    margin-left: 2.5% !important;
  }

  .el-checkbox__label {
    font-size: 18px !important;
  }

  .el-checkbox {

    font-size: 18px !important;
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

  @head_text: Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  @import "../../../assets/css/home_second_goods";
  .flextext {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;

  }
.shangpin_sousou{
  width: 430px;
}

</style>
